import './input-group.css';
export default {
  "inputGroup": "pf-v6-c-input-group",
  "inputGroupItem": "pf-v6-c-input-group__item",
  "inputGroupText": "pf-v6-c-input-group__text",
  "modifiers": {
    "searchExpandable": "pf-m-search-expandable",
    "expanded": "pf-m-expanded",
    "searchInput": "pf-m-search-input",
    "searchExpand": "pf-m-search-expand",
    "searchAction": "pf-m-search-action",
    "expandStart": "pf-m-expand-start",
    "box": "pf-m-box",
    "plain": "pf-m-plain",
    "disabled": "pf-m-disabled",
    "fill": "pf-m-fill"
  }
};